import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.SERVICO_ORCAMENTO.BUSCAR_TODOS_SERVICOS]({state}, orcamentoId) {
        const {filtros, paginacao} = state.resultadoBuscaTodosServicosOrcamento
        filtros.orcamentoId.value = orcamentoId
        const {data} = await api.servicoOrcamento.buscarTodos(filtros, paginacao)
        return data
    },

    async [actionTypes.SERVICO_ORCAMENTO.CADASTRAR_SERVICO](context, dados) {
        await api.servicoOrcamento.cadastrar(dados)
    },

    async [actionTypes.SERVICO_ORCAMENTO.EDITAR_SERVICO](context, dados) {
        await api.servicoOrcamento.editar(dados)
    },

    async [actionTypes.SERVICO_ORCAMENTO.EXCLUIR_SERVICO](context, dados) {
        await api.servicoOrcamento.excluir(dados)
    },
}